export const AUTHORIZATION_TOKEN = 'authorizationToken'
